import React, {Component} from 'react';
import Title from './Title/Title'
import List from './List/SubscriptionList'
import SearchBar from './SearchBar/SearchBar'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import SubSpreadTable from './SubTable';
import Page from '../framework/Page/Page';
import orderBy from 'lodash/orderBy';
import './subscription-info.css'
import {downLoadCSVFunc} from "../../utils/utility";
import moment from "moment/moment";
class SubscriptionsInfo extends Component {
  constructor(props) {
    super(props);
    this.throttle = true;
    this.state = {
      requestParams: {
        clientId: '',
        pageNumber: 1,
        pageSize: 15,
        sortColumn: 'clientName',
        order: 'asc'
      }
    }
  }
  componentDidMount () {
    this.props.getSubStats();
    this.props.getSearchData(this.state.requestParams);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.search_results.clients && this.throttle) {
      this.setState({
        requestParams: {
          ...this.state.requestParams,
          pageSize: nextProps.search_results.clients.total
        }
      }, () => {
        this.props.getAllSearchData(this.state.requestParams)
      })
      this.throttle = false;
    }
  }
  handleSearch (selectedItem) {
    let obj = {}
    if (selectedItem === '') {
      obj = {
        requestParams: {
          ...this.state.requestParams,
          clientId: '',
          pageNumber: 1,
          pageSize: 15
        }
      }
      this.goToPage(1)
    } else {
      obj = {
        requestParams: {
          ...this.state.requestParams,
          clientId: selectedItem,
          pageNumber: 1,
          pageSize: 15
        }
      }
    }
    this.setState(obj, () => {
      this.props.getSearchData(this.state.requestParams);
    })
  }
  nextBeClick (page) {
    this.pageAbleFunc(page)
  }
  previousBeClick (page) {
    this.pageAbleFunc(page)
  }
  goToPage (page) {
    this.pageAbleFunc(page)
  }
  pageAbleFunc (val) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        pageNumber: val,
        pageSize: 15
      }
    }, () => {
      this.props.getSearchData(this.state.requestParams);
    })
  }
  handleSortByClientName () {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        pageSize: 15,
        order: this.state.requestParams.order === 'desc' ? 'asc' : 'desc'
      }
    }, () => {
      this.props.getSearchData(this.state.requestParams);
    })
  }
  handleDownload () {
    let title = 'AudienceAnywhere Subscripions,,,\r\n'
    let total = `${this.props.subscription_total[0].label},${this.props.subscription_total[0].value},,\r\n`;
    let active = `${this.props.subscription_total[1].label},${this.props.subscription_total[1].value},,\r\n`;
    let data = '';
    let itemFun = (item) => {
      data += `"${item.clientName}",${item.bizUnitName||''},${(item.subscription && item.subscription.name)||''},${moment(item.createdTime).format('M/DD/YY')||''}\r\n`;
    }
    for (const v of this.props.all_search_results.clients.data) {
      if (v.children) {
        data += `"${v.clientName}",,${(v.subscription && v.subscription.name)||''},${moment(v.createdTime).format('M/DD/YY')||''}\r\n`;
        v.children.forEach(itemFun)
      } else {
        data += `"${v.clientName}",${v.bizUnitName||''},${(v.subscription && v.subscription.name)||''},${moment(v.createdTime).format('M/DD/YY')||''}\r\n`;
      }
    }
    let csv_string =
      title +
      total +
      active +
      ',,,\r\n' +
      'Client Name,Business Unit Name,Subscription,Subscription Start Date\r\n' +
      data
    downLoadCSVFunc(csv_string.trim(), 'AA_Subscriptions_' + moment().format("YYYYMMDD") );
  }
  render () {
    return (
      <MuiThemeProvider>
        <div className="subscription-info" style={{marginTop:'-20px'}}>
          <div className="title-wrapper">
            <Title
              handleDownload={() => this.handleDownload()}
            />
          </div>
          <div className="sub-info-container">
            <div className="common-wrapper">
              <h2>
                TOTAL NUMBER OF SUBSCRIPTIONS BY TIER
              </h2>
              <div className="list">
                <List
                  data={orderBy(this.props.subscription_total, ["label"], ["desc"])}
                />
              </div>
            </div>
            <div className="common-wrapper mt-20">
              <h2 className="border-title">
                SUBSCRIPTIONS
              </h2>
              <div className="search-bar">
                <SearchBar
                  clients={this.props.clients}
                  handleSearch={(selectedItem) => this.handleSearch(selectedItem)}
                />
                <div className="tag-info-table-wrapper">
                  <SubSpreadTable
                    handleSortByClientName={() => this.handleSortByClientName()}
                    tableHeaderArr={
                      [
                        {label: 'Client Name', value: 0},
                        {label: 'Business Unit Name', value: 1},
                        {label: 'Subscription', value: 2},
                        {label: 'Subscription Start Date', value: 3}
                      ]
                    }
                    bodyDataArr={
                      this.props.search_results.clients ? this.props.search_results.clients.data : []
                    }
                    tableHeaderWidthStyle={
                      ['22%', '22%', '22%', '16%']
                    }
                    renderCols={{
                      cols: [
                        'clientName',
                        'bizUnitName',
                        'subscription',
                        'subscriptionTierStartTime'
                      ]
                    }}
                  />
                  <Page
                    nextBeClick={(page) => this.nextBeClick(page)}
                    pageNumber={this.props.search_results.clients && this.props.search_results.clients.pageNumber}
                    pageCount={this.props.search_results.clients && this.props.search_results.clients.pageCount}
                    pageSize={this.props.search_results.clients && this.props.search_results.clients.pageSize}
                    nextGroupBeClick={(page) => this.nextGroupBeClick(page)}
                    previousGroupBeClick={(page) => this.previousGroupBeClick(page)}
                    previousBeClick={(page) => this.previousBeClick(page)}
                    pageBeClick={(page) => this.pageBeClick(page)}
                    total={this.props.search_results.clients && this.props.search_results.clients.total}
                    hasNext={this.props.search_results.clients && this.props.search_results.clients.hasNext}
                    hasPrevious={this.props.search_results.clients && this.props.search_results.clients.hasPrevious}
                    pagePlus={true}
                    selectRows={(page, row) => this.selectRows(page, row)}
                    goToPage={(page) => this.goToPage(page)}
                  />
                </div>

              </div>
            </div>
          </div>
        </div>
      </MuiThemeProvider>
    )
  }
}

export default SubscriptionsInfo;



// WEBPACK FOOTER //
// ./src/components/SubscriptionsInfo/Index.jsx